"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**************************************** PROJECT MODULES *****************************************/
var javelin_exports_1 = require("../../javelin-exports");
var date_modifier_1 = require("../../model/util/date-modifier");
var kotlin_map_factory_1 = require("../../util/kotlin-map-factory");
/******************************************** LOGGING *********************************************/
var util_1 = require("util");
var shared_1 = require("mad-logs/lib/shared");
var log = shared_1.logFactory('dose-generators.ts', shared_1.Styles.cult);
/******************************************** HELPERS *********************************************/
/**
 * Construct a rule based on the Rule string
 */
var buildRules = function (rules, generatorId) {
    var rulesData = JSON.parse(rules);
    if (rulesData.length === 0)
        return [];
    return rulesData.map(function (curRule) {
        var outName = parseInt(curRule.name.toString(), 10);
        var outId = "" + generatorId + outName;
        // {name: 0, value: 1}
        if (typeof curRule.value === 'number' || curRule.value instanceof Number) {
            var outValue = curRule.value.toString();
            return new javelin_exports_1.Rule(outId, generatorId, outName, outValue);
        }
        // {name: 2, value: "c846194b-6aa1-4c41-ab1e-0cc89fccd810"}
        if (typeof curRule.value === 'string') {
            var outValue = curRule.value;
            return new javelin_exports_1.Rule(curRule.value, generatorId, outName, outValue);
        }
        // {name: 0, value: {years: 10, months: 4, weeks: 1, days: 1}}
        if (curRule.value &&
            (typeof curRule.value.years === 'number' || curRule.value.years instanceof Number)) {
            var outValue = JSON.stringify(curRule.value);
            return new javelin_exports_1.Rule(outId, generatorId, outName, outValue);
        }
        // {name: 0, value: {id:       "4548fe03-0040-466c-bcc6-2c77c2a1e6e6",
        //                   interval: {years: 1, months: 4, weeks: 1, days: 1}}}
        if (curRule.value && curRule.value.interval && curRule.value.id) {
            var outValue = JSON.stringify(curRule.value);
            return new javelin_exports_1.Rule(curRule.value.id, generatorId, outName, outValue);
        }
        // {name:6,value:[{years:0,months:3,weeks:0,days:0},
        //                {years:0,months:3,weeks:0,days:0}]}
        if (curRule.value &&
            curRule.value.length &&
            curRule.value.length > 0 &&
            (typeof curRule.value[0].years === 'number' || curRule.value[0].years instanceof Number)) {
            var outValue = JSON.stringify(curRule.value);
            var outId_1 = curRule.name;
            return new javelin_exports_1.Rule(outId_1, generatorId, outName, outValue);
        }
        throw new TypeError("Invalid rule given: " + JSON.stringify(curRule));
    });
};
/**
 * DoseGenerator factory: construct DoseGenerator object from data in schedules.json
 */
var buildDoseGenerator = function (doseGeneratorData) {
    log.verbose('doseGeneratorData:', doseGeneratorData);
    var rules = buildRules(doseGeneratorData.rules, doseGeneratorData.generatorId);
    return new javelin_exports_1.DoseGenerator(doseGeneratorData.generatorId, doseGeneratorData.conceptId, doseGeneratorData.collectionId, doseGeneratorData.scheduleId, doseGeneratorData.active, doseGeneratorData.age
        ? new date_modifier_1.DateModifier(doseGeneratorData.age.years, doseGeneratorData.age.months, doseGeneratorData.age.weeks, doseGeneratorData.age.days)
        : null, kotlin_map_factory_1.dirtyKotlinMap(doseGeneratorData.descriptions), rules);
};
/****************************************** DATA EXPORT *******************************************/
// Memoized array of DoseGeneratorInstance objects built from raw content data
var _doseGenerators;
/**
 * Export array of DoseGenerator objects [lazy]
 * Build collection on 1st run, then memoize (the content data is immutable)
 */
exports.doseGenerators = function (rawContentData) {
    _doseGenerators = _doseGenerators || rawContentData.doseGenerators.map(buildDoseGenerator);
    log.verbose("doseGenerators:", util_1.inspect(_doseGenerators, false, 10, true));
    return _doseGenerators;
};
//# sourceMappingURL=dose-generators.js.map